import { Badge } from '@/components/ui/badge';

interface MeMedStatusBadgeProps {
  status: 'PENDING' | 'SYNCED' | 'FAILED' | 'SIGNED' | 'CANCELLED';
  memedId?: string;
}

export function MeMedStatusBadge({ status, memedId }: MeMedStatusBadgeProps) {
  const statusConfig = {
    PENDING: { color: 'warning', label: 'Aguardando' },
    SYNCED: { color: 'success', label: 'Sincronizado' },
    FAILED: { color: 'error', label: 'Falhou' },
    SIGNED: { color: 'primary', label: 'Assinado' },
    CANCELLED: { color: 'secondary', label: 'Cancelado' },
  };

  const config = statusConfig[status] || statusConfig.PENDING;

  return (
    <Badge variant={config.color as any} className="gap-1">
      {config.label}
      {memedId && <span className="text-xs opacity-70">#{memedId.slice(-6)}</span>}
    </Badge>
  );
}
